// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__rpDPF","buy_from_btn_wrapper":"styles_buy_from_btn_wrapper__YTiXb","products_title":"styles_products_title__Qphr3"};